import { render, staticRenderFns } from "./StartSession.vue?vue&type=template&id=1f1f760c&"
import script from "./StartSession.vue?vue&type=script&lang=js&"
export * from "./StartSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports